module.exports = __webpack_public_path__ + "static/dl1-screen4-e44ebffa4fdecc9bcffd20a1f2a541e0.png";